import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/license/mutationTypes';

export default {
  [types.SET_LICENSES]: createSetPropMutation('licenses', []),
  [types.SET_DEFAULT_LICENSE]: createSetPropMutation('defaultLicense', []),
  [types.CLEAR_LICENSES]: createClearPropMutation('licenses', []),
  [types.CLEAR_DEFAULT_LICENSE]: createClearPropMutation('defaultLicense', []),
};
